




















import '../../styles/common-modal.css'
import Modal from './modal/Modal.vue'
import ModalBody from './modal/ModalBody.vue'
import { CIcon } from '@coreui/icons-vue'
import { cidTrash } from '@coreui/icons-pro'
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      trashIcon: cidTrash,
    }
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    item: {
      type: String,
      required: true,
    },
  },
  components: { Modal, ModalBody, CIcon },
  name: 'RemoveItemModal',
})
